import { useState } from 'react';
import { JoveProjectTypeEnum } from '@jove-frontend/enums';
import { combineQuoteCoverOptionList, getDeductionMethodMap, handleQuotePriceDateInfo, useQuotePriceDetailInfo } from '@jove-frontend/uikit';

export const usePolicyCardDetailInfo = () => {
  const [currentCoverList, setCurrentCoverList] = useState([]);
  const [currentPriceList, setCurrentPriceList] = useState([]);
  const [currentPaymentScheduleList, setCurrentPaymentScheduleList] = useState([]);
  const [renewCoverList, setRenewCoverList] = useState([]);
  const [renewPriceList, setRenewPriceList] = useState([]);
  const [renewPaymentScheduleList, setRenewPaymentScheduleList] = useState([]);
  const [renewDraftCoverList, setRenewDraftCoverList] = useState([]);
  const [renewDraftPriceList, setRenewDraftPriceList] = useState([]);
  const [renewDraftPaymentScheduleList, setRenewDraftPaymentScheduleList] = useState([]);
  const { generateQuotePriceSummaryInfoList, generateQuotePriceSummaryTotalInfoList, generateUniversalDisplaySelectCoverInfoList } =
    useQuotePriceDetailInfo();

  const updateAllCoverageAndPriceInfoList = (policy) => {
    if (policy) {
      setCurrentCoverList(
        generateUniversalDisplaySelectCoverInfoList(policy.quotePayload?.covers, policy.coverOptions?.data, {
          providerCode: policy.providerCode,
          coverType: policy.quotePayload?.coverType,
        })
      );
      setCurrentPriceList(
        evaluatePriceData({
          quoteData: policy.quotePayload,
          pricesInfo: policy.prices,
          coverOptions: policy.coverOptions?.data,
        })
      );
      setCurrentPaymentScheduleList(policy.prices?.billing_schedule);
      setRenewCoverList(
        generateUniversalDisplaySelectCoverInfoList(policy.renewalQuotePayload?.covers, policy.renewalCoversOptions?.data, {
          providerCode: policy.providerCode,
          coverType: policy.quotePayload?.coverType,
        })
      );
      setRenewPriceList(
        evaluatePriceData({
          quoteData: policy.renewalQuotePayload,
          pricesInfo: policy.renewalPrices,
          coverOptions: policy.renewalCoversOptions?.data,
        })
      );
      setRenewPaymentScheduleList(policy.renewalPrices?.billing_schedule);
      setRenewDraftCoverList(
        generateUniversalDisplaySelectCoverInfoList(policy.renewalDraftQuotePayload?.covers, policy.renewalCoversOptions?.data, {
          providerCode: policy.providerCode,
          coverType: policy.quotePayload?.coverType,
        })
      );
      setRenewDraftPriceList(
        evaluatePriceData({
          quoteData: policy.renewalDraftQuotePayload,
          pricesInfo: policy.renewalDraftPrices,
          coverOptions: policy.renewalCoversOptions?.data,
        })
      );
      setRenewDraftPaymentScheduleList(policy.renewalDraftPrices?.billing_schedule);
    }
  };

  /**
   * methods
   */
  const evaluatePriceData = (data: { quoteData: any; coverOptions: any; pricesInfo: any; isRenew?: boolean }) => {
    const { quoteData, coverOptions, pricesInfo } = data;
    combineQuoteCoverOptionList(coverOptions, pricesInfo, { useDefault: true });
    const detailPriceInfo = handleQuotePriceDateInfo(pricesInfo);

    const tempList = [];
    tempList.push({
      title: 'Payment Plan',
      content: quoteData?.billingCycle === getDeductionMethodMap().monthly ? '9 Monthly Installments' : 'Annual',
      isPaymentPlan: true,
    });
    tempList.push(...generateQuotePriceSummaryInfoList(detailPriceInfo));
    tempList.push(
      ...generateQuotePriceSummaryTotalInfoList(detailPriceInfo, { projectSource: JoveProjectTypeEnum.dashboard }).map((item) => {
        item['isBoldMore'] = true;
        return item;
      })
    );
    return tempList;
  };

  return {
    updateAllCoverageAndPriceInfoList,
    currentCoverList,
    currentPriceList,
    currentPaymentScheduleList,
    renewCoverList,
    renewPriceList,
    renewPaymentScheduleList,
    renewDraftCoverList,
    renewDraftPriceList,
    renewDraftPaymentScheduleList,
  };
};
